import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navLinks = [{
    name: '首页',
    en: 'Home'
  }, {
    name: '服务',
    en: 'Services'
  }, {
    name: '关于我们',
    en: 'About'
  }, {
    name: '评价',
    en: 'Reviews'
  }];
  return <nav className="w-full py-6 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto relative z-20" data-id="element-71">
      <div className="flex items-center justify-between" data-id="element-72">
        {/* Logo */}
        <div className="flex items-baseline gap-2 cursor-pointer" data-id="element-73">
          <span className="text-2xl font-serif font-bold text-brand-green tracking-wide" data-id="element-74">
            新加坡爽吧
          </span>
          <span className="text-xl font-serif font-semibold text-brand-gold" data-id="element-75">
            Shiok8
          </span>
        </div>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-8" data-id="element-76">
          <div className="flex gap-8" data-id="element-77">
            {navLinks.map(link => <a key={link.name} href={`#${link.en.toLowerCase()}`} className="group flex items-center gap-1.5 text-brand-text hover:text-brand-green transition-colors font-medium text-sm" data-id="element-78">
                <span data-id="element-79">{link.name}</span>
                <span className="text-brand-muted text-xs group-hover:text-brand-green/70 transition-colors" data-id="element-80">
                  ({link.en})
                </span>
              </a>)}
          </div>

          <button className="bg-brand-green hover:bg-brand-green-light text-white px-6 py-2.5 rounded-full font-medium text-sm transition-all shadow-sm hover:shadow-md flex items-center gap-1.5" data-id="element-81">
            <span data-id="element-82">立即预约</span>
            <span className="text-white/80 text-xs font-normal" data-id="element-83">
              (Book Now)
            </span>
          </button>
        </div>

        {/* Mobile Menu Button */}
        <button className="md:hidden p-2 text-brand-green" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-84">
          {isMobileMenuOpen ? <X size={24} data-id="element-85" /> : <Menu size={24} data-id="element-86" />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && <div className="absolute top-full left-0 w-full bg-brand-bg/95 backdrop-blur-md shadow-lg border-t border-brand-gold/10 md:hidden py-4 px-4 flex flex-col gap-4 z-50 rounded-b-2xl" data-id="element-87">
          {navLinks.map(link => <a key={link.name} href={`#${link.en.toLowerCase()}`} className="flex items-center gap-2 text-brand-text p-2 hover:bg-brand-gold/10 rounded-lg transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-88">
              <span className="font-medium" data-id="element-89">{link.name}</span>
              <span className="text-brand-muted text-sm" data-id="element-90">({link.en})</span>
            </a>)}
          <button className="bg-brand-green text-white px-6 py-3 rounded-full font-medium text-sm w-full mt-2 flex items-center justify-center gap-2" data-id="element-91">
            <span data-id="element-92">立即预约</span>
            <span className="text-white/80 text-xs font-normal" data-id="element-93">
              (Book Now)
            </span>
          </button>
        </div>}
    </nav>;
}